import styles from "./FlowBeam.module.css";

type Props = {
  streams?: number;
};

export default function FlowBeam(props: Props) {
  const { streams = 7 } = props;

  return (
    <div className={styles.container} aria-hidden="true">
      <span className={styles.glow} />
      <div className={styles.streams}>
        {Array.from({ length: streams }).map((_, i) => (
          <span className={styles.stream} key={i} />
        ))}
      </div>
      <span className={styles.node} />
    </div>
  );
}
